/** Convert stored legacy stream URLs without changing their host, ID or query. */
export const getPublicDocumentStreamUrl = (url: string): string => {
  if (/^(blob:|data:)/i.test(url)) return url;

  const suffixIndex = url.search(/[?#]/);
  const path = suffixIndex < 0 ? url : url.slice(0, suffixIndex);
  const suffix = suffixIndex < 0 ? "" : url.slice(suffixIndex);

  return path.replace(
    /(^|\/)Document\/stream\/(?!public(?:\/|$))/i,
    "$1Document/stream/public/",
  ) + suffix;
};
